export default __webpack_public_path__ + "assets/img/negotiationOffering.cdc54ceb86926631f2bc2300d5effe43.png";